import * as THREE from 'three'

import BaseObject from '@glass-designer/objects/baseObject'
import EditingArrow from '@glass-designer/objects/editingArrow'

import GlassDesignerTypes from '@glass-designer/types'


// Editing Move Group Handle
// Displays a group of arrows to move an object along axis
export default class EditingMoveGroupHandle extends BaseObject {
  constructor(editor, options = {}) {
    super(editor)

    this.colour = options.colour || '#FFFFFF'
    this.moveAllArrowColour = '#808080'
    this.horzArrowColour = '#808080'
    this.vertArrowColour = '#808080'
    this.moveAllArrowHoverColour = '#2E50BF'
    this.horzArrowHoverColour = '#A00000'
    this.vertArrowHoverColour = '#2EBF50'

    this.axisHorizontalEnabled = true
    this.axisVerticalEnabled = true
    this.moveAllEnabled = false

    this.position = new THREE.Vector2(0, 0)

    this.sceneObject = new THREE.Object3D()
    this.updateSceneObject()

    this.moveAllArrow = new EditingArrow(this.editor, {
      colour: this.moveAllArrowColour,
      hoverColour: this.moveAllArrowHoverColour,
      arrowTexture: editor.resources.arrowTextureMoveAll
    })
    this.moveAllArrow.setRotation(0)
    this.moveAllArrow.setObjectEventListener(this)
    this.addChildObject(this.moveAllArrow)

    this.leftArrow = new EditingArrow(this.editor, { colour: this.horzArrowColour, hoverColour: this.horzArrowHoverColour })
    this.leftArrow.setRotation(180)
    this.leftArrow.setObjectEventListener(this)
    this.addChildObject(this.leftArrow)
    this.rightArrow = new EditingArrow(this.editor, { colour: this.horzArrowColour, hoverColour: this.horzArrowHoverColour })
    this.rightArrow.setObjectEventListener(this)
    this.addChildObject(this.rightArrow)

    this.upArrow = new EditingArrow(this.editor, { colour: this.vertArrowColour, hoverColour: this.vertArrowHoverColour })
    this.upArrow.setRotation(-90)
    this.upArrow.setObjectEventListener(this)
    this.addChildObject(this.upArrow)
    this.downArrow = new EditingArrow(this.editor, { colour: this.vertArrowColour, hoverColour: this.vertArrowHoverColour })
    this.downArrow.setRotation(90)
    this.downArrow.setObjectEventListener(this)
    this.addChildObject(this.downArrow)

    this.moveAllArrow.setPosition(this.position)
    this.leftArrow.setPosition(this.position)
    this.rightArrow.setPosition(this.position)
    this.upArrow.setPosition(this.position)
    this.downArrow.setPosition(this.position)
  }

  // onBeforeRender
  // Called prior to rendering of the object
  onBeforeRender() {
    super.onBeforeRender()

    var arrowScale = 1.0 / this.editor.camera.zoom
    var offsetAmount = 28

    // Adjust positions based on scaling
    this.moveAllArrow.setPosition(new THREE.Vector2(this.position.x, this.position.y))
    this.leftArrow.setPosition(new THREE.Vector2(this.position.x - offsetAmount * arrowScale, this.position.y))
    this.rightArrow.setPosition(new THREE.Vector2(this.position.x + offsetAmount * arrowScale, this.position.y))
    this.upArrow.setPosition(new THREE.Vector2(this.position.x, this.position.y - offsetAmount * arrowScale))
    this.downArrow.setPosition(new THREE.Vector2(this.position.x, this.position.y + offsetAmount * arrowScale))

    this.moveAllArrow.setVisible(this.visible && this.moveAllEnabled)
    this.leftArrow.setVisible(this.visible && this.axisHorizontalEnabled)
    this.rightArrow.setVisible(this.visible && this.axisHorizontalEnabled)
    this.upArrow.setVisible(this.visible && this.axisVerticalEnabled)
    this.downArrow.setVisible(this.visible && this.axisVerticalEnabled)
  }


  // Update the position of the handle
  setPosition(pos) {
    this.position.set(pos.x, pos.y)
  }

  // Get the position of the hand;e
  getPosition() {
    return this.position
  }


  /**
   * Setup the move handles to be axis restricted or freeform move
   */
  setupHandles(options = {}) {
    this.axisHorizontalEnabled = !!options.horizontalEnabled
    this.axisVerticalEnabled = !!options.verticalEnabled
    this.moveAllEnabled = !!options.moveAllEnabled
  }


  /**
   * Build the initial drawing objects to display the editing line
   */
  updateSceneObject() {
    this.clearSceneObject()

  }


  /**
   * Receive an object event from objects we're listening too
   */
  onReceiveObjectEvent(object, eventType, data) {
    if(eventType == GlassDesignerTypes.ObjectEventTypes.objectCaptured) {
      var direction = new THREE.Vector2(0, 0)
      if(object == this.rightArrow)
        direction.set(1, 0)
      else if(object == this.leftArrow)
        direction.set(-1, 0)
      else if(object == this.upArrow)
        direction.set(0, -1)
      else if(object == this.downArrow)
        direction.set(0, 1)
      else if(object == this.moveAllArrow)
        direction.set(1, 1)
      else
        return

      // Notify any listener the handle has been moved
      this.sendObjectEvent(GlassDesignerTypes.ObjectEventTypes.objectCaptured, {
        position: this.position,
        direction: direction
      })
    }
    if(eventType == GlassDesignerTypes.ObjectEventTypes.objectMoved) {
      if(object == this.rightArrow || object == this.leftArrow) {
        this.position.x += data.moveOffset.x
      }
      if(object == this.upArrow || object == this.downArrow) {
        this.position.y += data.moveOffset.y
      }
      if(object == this.moveAllArrow) {
        this.position.x += data.moveOffset.x
        this.position.y += data.moveOffset.y
      }
      this.sendObjectEvent(GlassDesignerTypes.ObjectEventTypes.objectMoved, {
        position: this.position,
      })
    }

    if(eventType == GlassDesignerTypes.ObjectEventTypes.objectReleased) {
      this.sendObjectEvent(GlassDesignerTypes.ObjectEventTypes.objectReleased, {
        position: this.position,
      })
    }
  }
  

}
